import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Col, Row, Button, Input } from 'reactstrap';
import TeamTable from './TeamTable';
import { addTeam, getShifts, getSolutions, getTeams, getZones } from 'store/actions';
import CreateTeam from './CreateTeam';
import Breadcrumb from 'components/Common/Breadcrumb2';

const TeamList = () => {
    // const [selectedGroup, setSelectedGroup] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    const dispatch = useDispatch();
    const teams = useSelector((state) => state.Team.teams);
    const shifts = useSelector(state=>state.Shift.shifts);
    const loading = useSelector((state) => state.Team.loading);
    const error = useSelector((state) => state.Team.error);
    const solutions = useSelector((state) => state.Solution.solutions);
    const zones = useSelector(state => state?.Zone.zones);
    const [selectedSolution,setSelectedSolution] = useState();

    // Fetch teams when component mounts
    useEffect(() => {
        if(loading)return;
        // Dispatch the action to fetch teams
        dispatch(getShifts());
        dispatch(getSolutions())
        dispatch(getZones())
    }, [dispatch]);

    useEffect(()=>{
        dispatch(getTeams(true,selectedSolution));
    },[selectedSolution])

    // const handleSelectGroup = (selectedOption) => {
    //     setSelectedGroup(selectedOption);
    // };

    const handleSubmit = (data,onClose) => {
        dispatch(addTeam(data,true,onClose));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <CreateTeam zones={zones} solutions={solutions} visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} shifts={shifts}/>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3">
                <Breadcrumb title="Teams" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Teams", link: '#' }]} />
                    {permissions2?.map(item=>item?.permissionName)?.includes("Add Teams") &&<Button className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" onClick={() => setIsOpen(true)}>
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>

                <TeamTable zones={zones}  solutions={solutions} selectedSolution={selectedSolution} setSelectedSolution={setSelectedSolution} set List={teams?.Data} loading={loading} error={error} shifts={shifts}/>
            </div>
        </>
    );
};

export default TeamList;
